function env(name: string, fallback: string): string {
  const v = import.meta.env[name];
  return typeof v === "string" && v.trim() ? v.trim() : fallback;
}

export const config = {
  appName: "GovSuite",
  demoLabel: "Demo",
  deploymentTier: "demo_sandbox" as const,
  cognito: {
    userPoolId: env("VITE_COGNITO_USER_POOL_ID", "us-east-1_kzWJAZq89"),
    clientId: env("VITE_COGNITO_CLIENT_ID", "59isuh6053meg8dm2nor6o9b5s"),
    region: env("VITE_AWS_REGION", "us-east-1"),
  },
  apiUrl: env("VITE_DEMO_API_URL", "https://21kv7zzut8.execute-api.us-east-1.amazonaws.com"),
  version: "0.1.0",
} as const;
